<template>
  <div>
    <div class="c-mgb-20">
      <Button
        type="secondary"
        class="c-mgr-20"
        @click="create"
        v-if="dbtype.type === 'ks3'"
        :disabled="dbtype.db === 'sample_database'"
        >创建数据表</Button
      >
      <Button
        type="secondary"
        @click="del"
        :disabled="dbtype.db === 'sample_database'"
        >删除数据库</Button
      >
    </div>
    <Table
      :data="tableInfo"
      checkType="none"
      v-if="dbtype.type === 'ks3'"
      :fixHeader="dbListHeight"
    >
      <TableColumn key="tableInfo.TableName" title="表名称" width="100">
        <template slot-scope="item">
          <a @click="read(item)"> {{ item.TableName }}</a>
        </template>
      </TableColumn>
      <TableColumn key="tableInfo.Location" title="存储位置">
        <span slot-scope="item">{{ item.Location }}</span>
      </TableColumn>
      <TableColumn key="tableInfo.CreateTime" title="创建时间" width="100">
        <span slot-scope="item">{{
          item.CreateTime | datefmt("YYYY-MM-DD HH:mm:ss")
        }}</span>
      </TableColumn>
      <TableColumn key="tableInfo.UpdateTime" title="更新时间" width="100">
        <span slot-scope="item">{{
          item.UpdateTime | datefmt("YYYY-MM-DD HH:mm:ss")
        }}</span>
      </TableColumn>
      <TableColumn
        title="操作"
        key="op"
        ignore
        v-if="dbtype.db !== 'sample_database'"
        width="200"
      >
        <template slot-scope="item, index">
          <a class="c-mgr-10"><span @click="query(item)">查询数据</span></a>
          <a class="c-mgr-10"><span @click="edit(item)">编辑表</span></a>
          <a><span @click="delTable(item, index)">删除表</span></a>
        </template>
      </TableColumn>
    </Table>
    <Table
      :data="tableInfo"
      checkType="none"
      v-if="dbtype.type === 'rds'"
      :fixHeader="dbListHeight"
    >
      <TableColumn key="tableInfo.TableName" title="表名称">
        <span slot-scope="item">{{ item.TableName }}</span>
      </TableColumn>
      <TableColumn key="tableInfo.DatabaseName" title="RDS数据库">
        <span slot-scope="item">{{ item.DatabaseName }}</span>
      </TableColumn>
      <TableColumn key="tableInfo.InstanceName" title="RDS实例">
        <span slot-scope="item">{{ item.InstanceName }}</span>
      </TableColumn>
      <TableColumn key="tableInfo.InstanceId" title="RDS实例ID">
        <span slot-scope="item">{{ item.InstanceId }}</span>
      </TableColumn>
      <TableColumn key="tableInfo.CreateTime" title="创建时间">
        <span slot-scope="item">{{
          item.CreateTime | datefmt("YYYY-MM-DD HH:mm:ss")
        }}</span>
      </TableColumn>
    </Table>
  </div>
</template>
<script>
import { Table, TableColumn } from 'kpc/components/table';
import { Button } from 'kpc/components/button';
export default {
  props: {
    tableInfo: {
      type: Array,
      default: function() {
        return [];
      }
    },
    dbtype: {
      type: Object,
      default: function() {
        return {};
      }
    },
    dbListHeight: {
      type: Number,
      default: 500
    }
  },
  mounted() {
    // console.log(this.dbListHeight, 'this.dbListHeight')
    // setInterval(() => {
    //   console.log(this.dbListHeight, 'this.dbListHeight')
    // }, 3000)
  },
  methods: {
    del() {
      this.$emit('del-clicked');
    },
    delTable(row, index) {
      this.$emit('deltable-clicked', { ...row, index });
    },
    query(item) {
      this.$emit('query', item);
    },
    edit(row) {
      this.$emit('edit-clicked', row);
    },
    read(row) {
      this.$emit('read-clicked', row);
    },
    create() {
      this.$emit('create-clicked');
    }
  },
  components: {
    Button,
    Table,
    TableColumn
    // Checkbox
  }
};
</script>
<style lang="stylus" scoped>
.k-form-item .k-label
    color #666
    font-size 14px
    display: inline-block
    font-weight: normal
    margin: 0
</style>
